var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.style }, [
    _c("div", { staticClass: "header-img" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.disabled,
              expression: "!disabled"
            }
          ],
          staticClass: "btn-upload"
        },
        [
          _c(
            "el-upload",
            {
              attrs: {
                action: "/upload",
                "show-file-list": false,
                "before-upload": _vm.beforeCardsUpload,
                "on-preview": _vm.handlePictureCardPreview,
                "on-remove": _vm.handleRemove,
                "on-success": _vm.handleSuccess
              }
            },
            [
              _c("el-button", { attrs: { size: "small", type: "primary" } }, [
                _vm._v("点击上传")
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.disabled,
              expression: "!disabled"
            }
          ],
          staticClass: "img-edit"
        },
        [
          _c("div", { staticClass: "edit-div" }, [
            _c("img", {
              staticClass: "image",
              attrs: {
                id: "image" + _vm.ckey,
                src: _vm.imgSrc
                  ? _vm.imgSrc
                  : "https://res.wx.qq.com/wxopenres/htmledition/images/spacer32f740.gif"
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img-view" }, [
      _c("div", { staticClass: "text" }, [_vm._v("头像预览")]),
      _vm._v(" "),
      _c("div", { staticClass: "square" }, [
        _c("div", { staticClass: "preview" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "circle" }, [
        _c("div", { staticClass: "preview" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }